import { render, staticRenderFns } from "./CmmNmrcField.vue?vue&type=template&id=2b29704a&"
import script from "./CmmNmrcField.vue?vue&type=script&lang=js&"
export * from "./CmmNmrcField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports